module.exports = __webpack_public_path__ + "images/products-groups-dark-30c466be.svg";